import React from 'react'

interface ExternalLinkProps {
  size?: number
  color?: string
}

export const ExternalLink: React.FC<ExternalLinkProps> = ({
  size = 10,
  color = '#fff',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.333 5.417v2.916a.833.833 0 01-.833.834H1.667a.833.833 0 01-.834-.834V2.5a.833.833 0 01.834-.833H4.583M6.667.833h2.5v2.5M4.167 5.833l5-5"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
